// extracted by mini-css-extract-plugin
export default {"infoPanel":"infoPanel_infoPanel__AEEKG","content":"infoPanel_content__1-ks-"};